import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ICmsValueBox } from 'src/app/shared/models/cmsValueBox';
import { ValueBoxsService } from 'src/app/shared/services-v2/value-boxs/value-boxs.service';

@Component({
  selector: 'app-modal-editar',
  templateUrl: './modal-editar.component.html',
  styleUrls: ['./modal-editar.component.scss'],
})
export class ModalEditarComponent implements OnInit {
  form: FormGroup;
  valueBox: ICmsValueBox;
  iconControl = new FormControl();
  valueBoxsService = inject(ValueBoxsService);
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  fb = inject(FormBuilder);

  ngOnInit(): void {
    this.valueBox = this.config.data.valueBox;

    // Inicializamos el control del ícono con el valor actual
    this.iconControl.setValue(this.valueBox.image);

    this.form = this.fb.group({
      _id: [this.valueBox._id],
      image: this.iconControl, // Asociamos el FormControl del ícono
      title: [this.valueBox.title, Validators.required],
      subtext1: [this.valueBox.subtext1],
      subtext2: [this.valueBox.subtext2],
      url: [this.valueBox.url],
      active: [this.valueBox.active],
      order: [this.valueBox.order],
    });
  }
  save(): void {
    if (this.form.invalid) {
      console.log('Formulario inválido');
      return;
    }
    const id = this.valueBox._id;

    this.valueBoxsService.updateOne(id, this.form.value).subscribe({
      next: () => {
        this.ref.close('SUCCESS'); 
      },
      error: (err) => {
        this.ref.close('ERROR'); 
      },
    });
  }

  cancel(): void {
    this.ref.close(false); // Pasamos false para indicar cancelación
  }
}
